module.exports = __webpack_public_path__ + "img/wise-token.nl.a6fb96ac.png";